import * as React from "react";
import { CSSTransition } from "react-transition-group";

function Fade(props) {
    const timeout = props.timeout ? props.timeout : 300;

    return (
        <CSSTransition classNames="tmp-fade" unmountOnExit timeout={timeout} {...props}>
            {(state, childProps) => {
                return React.cloneElement(props.children, {
                    style: {
                        transition: "opacity " + timeout + "ms",
                        ...childProps.style,
                    },
                    ...childProps,
                });
            }}
        </CSSTransition>
    );
}

export default Fade;
